export const environment = {
  production: true,
  apiUrl: '',
  cloudFrontURL: '/ui'
};
